import { IHttpApi } from '@cian/http-api/shared';

import { createGetUserFavoritesCountModel } from '@cian/api-models/favorites/v1/get_user_favorites_count';

export function getUserFavoritesCount(httpApi: IHttpApi) {
  return httpApi.fetch(
    createGetUserFavoritesCountModel({
      parameters: {},
    }),
  );
}
